export enum Permission {
  IsAdmin = 0,
  CreateAndEditDailyWorkReport = 1,
  ViewCalculatedPayroll = 2,
  ViewPayrollHistory = 3,
  AdminPayroll = 4,
  AdminEmployees = 5,
  AdminProducts = 6,
  AdminFarms = 7,
  AdminSettings = 8,
  ViewSettings = 9,
  ViewDailyWorkReportsOfOtherUsers = 10,
  /** Not a client permission: resolved from the platform identity and never granted by isAdmin. */
  PlatformAdmin = 11,
}

export function getPermissionLabel(
  permission: Permission
): string {
  switch (permission) {
    case Permission.CreateAndEditDailyWorkReport:
      return 'Crear y editar reportes de trabajo'
    case Permission.ViewCalculatedPayroll:
      return 'Ver y calcular planilla'
    case Permission.ViewPayrollHistory:
      return 'Ver historial de planillas'
    case Permission.AdminPayroll:
      return 'Administrar planilla'
    case Permission.AdminEmployees:
      return 'Administrar empleados'
    case Permission.AdminProducts:
      return 'Administrar inventario de productos'
    case Permission.AdminFarms:
      return 'Administrar fincas'
    case Permission.AdminSettings:
      return 'Administrar configuración'
    case Permission.ViewSettings:
      return 'Ver configuración'
    case Permission.ViewDailyWorkReportsOfOtherUsers:
      return 'Ver reportes de trabajo de otros usuarios'
    case Permission.PlatformAdmin:
      return 'Administrador de plataforma'
    default:
      return 'Desconocido'
  }
}

export interface Tenant {
    name: string
    id: number
}

export interface Client {
    id: number
    name: string
    description: string
}
export interface UserInformation {
  id: number
  email: string
  firstName: string
  lastName: string  
  imageUrl?: string
  isApprover: boolean
  isAdmin: boolean
  isHidden: boolean
  tenants: Tenant[]
  client: Client
  permissions: string[]
  isDeleted: boolean
  createdDate: string
  modifiedDate: string
  modifiedByUserEmail: string
}

export interface User {
    userid: number
    username: string
    email: string
    imageurl?: string
    isApprover: boolean
    isAdmin: boolean
    client: Client
}

export interface DecodedToken {
    userid: number
    username: string
    email: string
    tenants: string
    imageurl?: string
}

export enum UserStatus {
  Active = 1,
  Inactive = 2,
  All = 3
}

export function getUserStatusLabel(
  status: UserStatus
): string {
  switch (status) {
    case UserStatus.Active:
      return 'Activo'
    case UserStatus.Inactive:
      return 'Desactivado'
    case UserStatus.All:
      return 'Todo'
    default:
      return 'Desconocido'
  }
}

export function getFullName(user: UserInformation) {
  return `${user.firstName} ${user.lastName}`
}


